import {
    GET_PRODUCT_BY_ID,
    GET_PRODUCT_BY_ID_ERROR,
    GET_PRODUCT_BY_ID_SUCCESS,
} from "core-web/state/models/Page/constants";
import { isEmpty, isObject } from "core-web/utils/object";

import Events from "core-web/libs/Events";
import GetProductByPartNo from "core-web/libs/GrebbCommerceAPI/Products/GetProductByPartNo";
import { NOT_ACTIVE_ONLINE } from "theme/config/constants";
import { ProductEvents } from "core-web/libs/Events/constants";
import { getFlag } from "core-web/utils/getFlag";
import { inServer } from "core-web/constants";
import store from "core-web/state/store";

export const getProductByPartNo = (partNo, applicationId, url) => async (dispatch) => {
    if (partNo) {
        dispatch({ type: GET_PRODUCT_BY_ID });
        try {
            const allPromises = await Promise.all([GetProductByPartNo(partNo, null, url, applicationId, true)]);
            const productResponse = allPromises[0];
            const reviewResponse = allPromises[1];

            const productData = JSON.parse(JSON.stringify(productResponse.data || {}));
            if (isEmpty(productData)) {
                throw new Error("Product data is empty");
            }

            const productVariants = productData.variants || [];
            const isMultipleVariants = productData.variants.length > 1;
            productData.variants = productVariants.filter((variant) => {
                if (getFlag(NOT_ACTIVE_ONLINE, variant?.format?.flags)) {
                    return false;
                }

                if (!isMultipleVariants) {
                    return true;
                }

                const variantParametrics = variant?.variant_parametrics || [];
                if (!variantParametrics.length) {
                    return false;
                }

                return variantParametrics.every((parametric) => parametric.value);
            });

            if (!inServer) {
                Events.trigger(ProductEvents.VIEW, {
                    data: productData,
                });
            }

            dispatch({
                type: GET_PRODUCT_BY_ID_SUCCESS,
                product: productData,
            });
        } catch (e) {
            // @todo: handle page when product couldn't fetch
            console.error(`ProductPage error: Could not fetch product with partNo ${partNo} from the API.`);
            dispatch({ type: GET_PRODUCT_BY_ID_ERROR });
        }
    }
};

export default (partNo, applicationId, url) => store.dispatch(getProductByPartNo(partNo, applicationId, url));
